import type {
    GrupoTransferenciaModel,
    ResumoEstabelecimentoModel,
} from "../../../services/extratoPixFornecedor"

export type { GrupoTransferenciaModel, ResumoEstabelecimentoModel }

export type ExtratoPixFornecedorModel = {
    dataInicio: string
    dataFim: string
    grupos: GrupoTransferenciaModel[]
    resumo: ResumoEstabelecimentoModel[]
    saldo: string
}

const hoje = () => {
    const d = new Date()
    return d.toISOString().slice(0, 10)
}

export const ExtratoPixFornecedorInicial: ExtratoPixFornecedorModel = {
    dataInicio: hoje(),
    dataFim: hoje(),
    grupos: [],
    resumo: [],
    saldo: "",
}
